<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, rrModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="rrModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="rr-main-vid">
        <video class="rr-main-vid" autoplay muted loop>
          <source src="@/assets/video/rr-intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="project-info">
        <h1>Radio Recliner</h1>
        <p>
          A pirate radio station run by real Resident DJs at retirement
          communities across the country, so they can stay connected while
          they're confined to their rooms.
        </p>
        <ul class="details">
          <li><label>Client:</label>Luckie & Co.</li>
          <li><label>Category:</label>Web Development</li>
          <li><label>Role:</label>Developer</li>
          <li>
            <label>Project URL:</label
            ><a target="_blank" href="https://https://radiorecliner.com/"
              >www.RadioRecliner.com</a
            >
          </li>
          <li>
            <label>Learn More:</label
            ><a
              target="_blank"
              href="https://www.luckie.com/work/radiorecliner/"
              >luckie.com/work/radiorecliner</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
.rr-main-vid {
  width: 100%;
}
</style>